/*
  BotechContext.js
*/

// Npm.
import React from 'react';

function notImplemented() {
  throw new Error('Not Implemented');
}

const BotechContext = React.createContext({
  
  // Older properties. Prefer the newer properties if possible.
  makeApiCall: notImplemented,
  userId: null,
  modelId: null,
  apiUrl: '',

  // Properties.
  readOnly: false,
  initialModel: null,
  saveModel: null,
  runModel: null,
  runModelExtraFormComponent: null,

});

export default BotechContext;
